export const RelatedEntities = {
    relatedEntities(linkedEntityClass) {
        let result;
        $.ajax({
            url: `${this.urlRoot}/${this.id}/view/${linkedEntityClass}`,
            method: 'GET',
            async: false,
            success: (data) => {
                result = data;
            }
        });
        
        return result;
    }
}
